import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { CustomTabs } from "../../../components";
import { HandlingFeeData, HandlingFeeStatement } from "./components";
import { HandlingFeeContextProvider } from "./context/HandlingFeeContext";
import styles from "./style.module.scss";

const HandlingFeeReport = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const tabItems = [
    {
      key: "handling_fee_data",
      title: t("mobile.handlingFee.data"),
      component: <HandlingFeeData />,
      destroyOnClose: true,
    },
    {
      key: "handling_fee_statement",
      title: t("mobile.home.menu.handlingFeeStatement"),
      component: <HandlingFeeStatement />,
      destroyOnClose: true,
    },
  ];
  const [activeTab, setActiveTab] = useState("handling_fee_data");

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  const getNowTab = () => {
    const tab = params.get("tab");
    if (tab) {
      const foundTab = tabItems.find((item) => item.key == tab);
      if (foundTab) {
        setActiveTab(tab);
      } else {
        setActiveTab(tabItems[0].key);
      }
    } else {
      setActiveTab(tabItems[0].key);
    }
  };

  useEffect(() => {
    getNowTab();
  }, []);
  return (
    <HandlingFeeContextProvider>
      <div className={styles.container}>
        <CustomTabs activeKey={activeTab} onTabChange={onTabChange} tabItems={tabItems} />
      </div>
    </HandlingFeeContextProvider>
  );
};
export default HandlingFeeReport;
